export { default } from './SameDayDepositBadge'
